<template>
  <page>
    <v-stepper value="1">
      <v-stepper-header non-linear>
        <v-stepper-step step="1" editable>General</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2" editable>Policy Header</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3" editable>Risk</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4" editable>Summary</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-card>
          <v-card-text>
            <v-layout row wrap>
              <v-flex lg8 xs12 order-xs2 order-lg1>
                <router-view ></router-view>
              </v-flex>
              <v-flex lg4 xs12 order-xs1 order-lg2>
                <policy-info></policy-info>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-stepper-items>
    </v-stepper>
  </page>
</template>

<script>
import PolicyInfo from './PolicyInfo'
export default {
  components: {
    PolicyInfo
  }
}
</script>

<style>

</style>
